import { render, staticRenderFns } from "./secondColumnList.vue?vue&type=template&id=764f9c84&scoped=true&"
import script from "./secondColumnList.vue?vue&type=script&lang=js&"
export * from "./secondColumnList.vue?vue&type=script&lang=js&"
import style0 from "./secondColumnList.vue?vue&type=style&index=0&id=764f9c84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764f9c84",
  null
  
)

export default component.exports